"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridColumnControlIcon = exports.StyledGridColumnMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const base_1 = require("../../../../../design/themes/base");
const DotsIcon_1 = require("../../../../../icons/DotsIcon");
exports.StyledGridColumnMenu = styled_components_1.default.div `
    position: absolute;
    top: 7px;
    right: 0;
    z-index: 99;
    background-color: ${base_1.baseTheme.colorBackgroundBlank.var()};
`;
exports.StyledGridColumnControlIcon = (0, styled_components_1.default)(DotsIcon_1.DotsIcon) `
    color: ${base_1.baseTheme.colorControlIcon.var()};
`;
//# sourceMappingURL=GridColumnMenu.styles.js.map